import { Grid } from "@mui/material";
import DeviceStats from "components/Charts/DeviceStats";
import PropTypes from "prop-types";

function StatisticsTab({ device, deviceLayout }) {
    return <DeviceStats title="Stats Chart" height={deviceLayout == 'mobile' ? "300px" : "calc((100svh - 23.5rem - 16px)/2)"} device={device} />;
}

StatisticsTab.propTypes = {
    device: PropTypes.object,
    deviceLayout: PropTypes.string
}

export default StatisticsTab;